import {
  ArticlePage,
  AutologPage,
  DealsPage,
  DesignSystemPage,
  HomePage,
  HomePageContextProvider,
  MaintenancePage,
  OffersPage,
  PartnersPage,
  ProductsContextProvider,
  ResultsPage,
  ZendeskSsoPage
} from 'components';
import { ProtectedRoute } from 'router';
import { authRoutes } from 'router/appRoutes/authRoutes';
import { dashboardRoutes } from 'router/appRoutes/dashboardRoutes';
import { giftcardRoutes } from 'router/appRoutes/giftcardRoutes';
import { legalRoutes } from 'router/appRoutes/legalRoutes';
import { leisurePurchaseRoutes } from 'router/appRoutes/leisurePurchaseRoutes';
import { leisureSportRoutes } from 'router/appRoutes/leisureSportRoutes';
import { travelBalanceRoutes } from 'router/appRoutes/travelBalanceRoutes';
import { travelPurchaseRoutes } from 'router/appRoutes/travelPurchaseRoutes';
import { travelRoutes } from 'router/appRoutes/travelRoutes';

export const routes = {
  autolog: {
    path: '/autolog',
    component: () => <AutologPage />
  },
  cseBenefitShow: {
    path: '/avantages-cse/:id',
    component: () => (
      <ProtectedRoute>
        <ArticlePage type="cse-benefits" isItemPage listCrumb="home" />
      </ProtectedRoute>
    )
  },
  designSystem: {
    path: '/design-system',
    component: () => (
      <ProtectedRoute>
        <DesignSystemPage />
      </ProtectedRoute>
    )
  },
  deals: {
    path: '/bons-plans',
    component: () => (
      <ProtectedRoute>
        <DealsPage />
      </ProtectedRoute>
    )
  },
  dealShow: {
    path: '/bons-plans/:id',
    component: () => (
      <ProtectedRoute>
        <ArticlePage type="deals" isItemPage filterByDate listCrumb="deals" />
      </ProtectedRoute>
    )
  },
  home: {
    path: '/',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <HomePage />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  },
  maintenance: {
    path: '/maintenance',
    component: () => <MaintenancePage />
  },
  offers: {
    path: '/offres-partenaires',
    component: () => (
      <ProtectedRoute>
        <OffersPage />
      </ProtectedRoute>
    )
  },
  partners: {
    path: '/partenaires',
    component: () => (
      <ProtectedRoute>
        <PartnersPage />
      </ProtectedRoute>
    )
  },
  results: {
    path: '/resultats',
    component: () => (
      <ProtectedRoute>
        <ProductsContextProvider>
          <ResultsPage />
        </ProductsContextProvider>
      </ProtectedRoute>
    )
  },
  sso: {
    path: '/sso',
    component: () => (
      <ProtectedRoute>
        <ZendeskSsoPage />
      </ProtectedRoute>
    )
  },
  ...authRoutes,
  ...legalRoutes,
  ...dashboardRoutes,
  // LEISURES & SPORTS
  ...leisureSportRoutes,
  ...leisurePurchaseRoutes,
  // TRAVELS
  ...travelRoutes,
  ...travelPurchaseRoutes,
  ...travelBalanceRoutes,
  // GIFTCARDS
  ...giftcardRoutes
};
